import { Button, Center, Paper, Stack, Text } from '@mantine/core'

import { Shell } from '@/components/Shell'

export const EventLoadError = ({
  onRetry,
  isFetching,
}: {
  onRetry: () => void
  isFetching: boolean
}) => (
  <Shell>
    <Paper p="xl">
      <Center>
        <Stack align="center" spacing="sm">
          <Text align="center">Unable to load event</Text>
          <Text size="sm" align="center">
            Please try loading the event again.
          </Text>
          <Button onClick={onRetry} loading={isFetching}>
            Try again
          </Button>
        </Stack>
      </Center>
    </Paper>
  </Shell>
)
